<app-layout-first-level>
  <app-layout-title>
    {{ 'app.base.home.title' | translate }}
  </app-layout-title>
  @let userInfo = this.profileName$ | async;
  <app-layout-content>
    @if (userInfo) {
      <div class="flex-row align-center g-space-md mb-space-md">
        <cam-user-logo [userInfo]="userInfo" size="lg"></cam-user-logo>
        <cam-title [level]="3"
          >{{
            'app.base.home.hello' | translate: { name: $safeNavigationMigration(userInfo.naming?.firstName) }
          }}
          👋</cam-title
        >
      </div>
    }

    <div class="flex-column g-space-xl">
      <app-dashboard-project></app-dashboard-project>
      <app-dashboard-quotation></app-dashboard-quotation>
      <app-dashboard-invoice></app-dashboard-invoice>
    </div>
  </app-layout-content>
</app-layout-first-level>

<cam-pwa></cam-pwa>
